export default __webpack_public_path__ + "static/media/agenda-and-screenplay.b16f44f3.pdf";